import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
 
const CustomCheck = ({ id, name, label, initialValue }) => {
    const [val, setVal] = useState(initialValue);
    
    return (
        <Form.Check 
            type="checkbox"
            id={id}
            name={name}
            label={label}
            value = {val}
            checked={val === "1"}
            onChange = {() => {setVal(val === "1" ? "" : "1")}}
        />
    );
}

export default CustomCheck;